import { useCallback } from 'react'
import { useEditorViewStore, useSelectionStore } from '@editorStores'
import type { PlanViewTab } from '@editorStores'
import { getDisplayedPlanViewTab, getPlanViewPlanElementTab } from '../utils'

/**
 * The plan view's sidebar tab. A table, comment or image card selected in the scene opens its tab
 * (see `getDisplayedPlanViewTab`); switching to another tab deselects it, otherwise the
 * selection would keep its tab open.
 */
const usePlanViewTab = () => {
  const chosenTab = useEditorViewStore(state => state.planView.tab)
  const setChosenTab = useEditorViewStore(state => state.setPlanViewTab)
  const planElementType = useSelectionStore(state => state.planSelection?.planElementType ?? null)
  const selectPlanElement = useSelectionStore(state => state.selectPlanElement)

  const tab = getDisplayedPlanViewTab(chosenTab, planElementType)
  const planElementTab = getPlanViewPlanElementTab(planElementType)

  const setTab = useCallback(
    (nextTab: PlanViewTab) => {
      if (planElementTab && nextTab !== planElementTab) selectPlanElement(null)
      setChosenTab(nextTab)
    },
    [planElementTab, selectPlanElement, setChosenTab],
  )

  return { tab, setTab }
}

export default usePlanViewTab
